
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import { GetInstructionFile } from './GetInstructionFile';

import "@/store/modules/forms/form16";
const form16State = namespace("Form16");

import "@/store/modules/forms/form17";
const form17State = namespace("Form17");

@Component
export default class AdditionalForms extends Vue { 

    @form16State.Action
    public UpdateCurrentOfferToSettleCostsId!: (newCurrentOfferToSettleCostsId: string) => void

    @form17State.Action
    public UpdateCurrentCertificateOfCostsId!: (newCurrentCertificateOfCostsId: string) => void
    
    updated=0;

    public startNewForm16Document(){
        this.UpdateCurrentOfferToSettleCostsId(null);
        this.$router.push({name: "start-form16" });
    }

    public startNewForm17Document(){
        this.UpdateCurrentCertificateOfCostsId(null);
        this.$router.push({name: "start-form17" });
    }

    public downloadInstructions(pdf_name){

        GetInstructionFile(pdf_name);
        
    }

}

